import api from './api';

export const getLoanTypesApi = (params) => api().get('/options-loan-types', { params });
export const addNewLoanTypeApi = (data) => api().post('/options-loan-types', data);
export const deleteLoanTypesApi = (params) => api().delete('/options-loan-types', { params });
export const updateLoanTypesApi = (params) => api().put(`/options-loan-types/${params.id}`, params.values);
